import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Download, MessageCircle, Star, Users, ArrowRight } from 'lucide-react';
import { AnimatedCounter } from './AnimatedCounter';
export function Hero() {
  const whatsappLink = 'https://wa.me/56984413571?text=Hola%20quiero%20informaci%C3%B3n%20sobre%20IndicadoresVIP%20📈';
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative min-h-screen flex items-center pt-24 pb-16 overflow-hidden" data-id="element-109">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-110"></div>

      {/* Abstract Chart Lines SVG */}
      <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-111">
        <svg className="w-full h-full" preserveAspectRatio="none" viewBox="0 0 1000 1000" data-id="element-112">
          <path d="M0,800 L100,750 L200,780 L300,600 L400,650 L500,400 L600,480 L700,200 L800,250 L900,100 L1000,150" fill="none" stroke="#D4AF37" strokeWidth="2" data-id="element-113" />
          <path d="M0,900 L150,850 L250,880 L350,700 L450,750 L550,500 L650,580 L750,300 L850,350 L1000,200" fill="none" stroke="rgba(255,255,255,0.2)" strokeWidth="1" strokeDasharray="5,5" data-id="element-114" />
        </svg>
      </div>

      {/* Glow Effects */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-gold/10 rounded-full blur-[100px]" data-id="element-115"></div>
      <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-emerald-500/5 rounded-full blur-[120px]" data-id="element-116"></div>

      <div className="container mx-auto px-6 relative z-10" data-id="element-117">
        <motion.div className="max-w-4xl mx-auto text-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-118">
          <motion.div variants={itemVariants} className="mb-6 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm" data-id="element-119">
            <span className="w-2 h-2 rounded-full bg-gold animate-pulse" data-id="element-120"></span>
            <span className="text-xs font-semibold tracking-widest text-zinc-300 uppercase" data-id="element-121">
              Educación Financiera Premium
            </span>
          </motion.div>

          <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl font-heading font-bold leading-tight mb-8" data-id="element-122">
            Aprende Trading con <br className="hidden md:block" data-id="element-123" />
            <span className="text-gradient-gold" data-id="element-124">IndicadoresVIP</span>
          </motion.h1>

          <motion.p variants={itemVariants} className="text-lg md:text-xl text-zinc-400 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-125">
            Tu guía para entender el mercado, operar con disciplina y mejorar tu
            análisis. Construye una base sólida para tu libertad financiera.
          </motion.p>

          <motion.div variants={itemVariants} className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16" data-id="element-126">
            <a href="#guia" className="w-full sm:w-auto px-8 py-4 bg-gold hover:bg-gold-light text-dark font-bold rounded-xl transition-all duration-300 flex items-center justify-center gap-2 shadow-gold-glow hover:shadow-gold-glow-lg group" data-id="element-127">
              <Download className="w-5 h-5 group-hover:-translate-y-1 transition-transform" data-id="element-128" />
              <span data-id="element-129">Descargar Guía Gratis</span>
            </a>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-gold/50 text-white font-semibold rounded-xl transition-all duration-300 flex items-center justify-center gap-2 group" data-id="element-130">
              <MessageCircle className="w-5 h-5 text-gold group-hover:scale-110 transition-transform" data-id="element-131" />
              <span data-id="element-132">Hablar por WhatsApp</span>
            </a>
          </motion.div>

          {/* Stats Row */}
          <motion.div variants={itemVariants} className="grid grid-cols-2 md:grid-cols-3 gap-6 pt-8 border-t border-white/10 max-w-3xl mx-auto" data-id="element-133">
            <div className="flex flex-col items-center" data-id="element-134">
              <div className="flex items-center gap-1 text-2xl font-heading font-bold text-white mb-1" data-id="element-135">
                <AnimatedCounter end={12847} prefix="+" data-id="element-136" />
              </div>
              <span className="text-sm text-zinc-500" data-id="element-137">Descargas</span>
            </div>
            <div className="flex flex-col items-center" data-id="element-138">
              <div className="flex items-center gap-1 text-2xl font-heading font-bold text-white mb-1" data-id="element-139">
                <AnimatedCounter end={5200} prefix="+" data-id="element-140" />
              </div>
              <span className="text-sm text-zinc-500" data-id="element-141">Estudiantes</span>
            </div>
            <div className="flex flex-col items-center col-span-2 md:col-span-1" data-id="element-142">
              <div className="flex items-center gap-1 text-2xl font-heading font-bold text-white mb-1" data-id="element-143">
                4.9
                <Star className="w-5 h-5 text-gold fill-gold" data-id="element-144" />
              </div>
              <span className="text-sm text-zinc-500" data-id="element-145">Valoración</span>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}